"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var styles = _interopRequireWildcard(require("./title.module.scss"));

var _excluded = ["wrapper", "size", "color", "family", "weight", "gradient", "noMargin", "children", "className", "transform", "truncate"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Title = function Title(_ref) {
  var Wrapper = _ref.wrapper,
      size = _ref.size,
      color = _ref.color,
      family = _ref.family,
      weight = _ref.weight,
      gradient = _ref.gradient,
      noMargin = _ref.noMargin,
      children = _ref.children,
      className = _ref.className,
      transform = _ref.transform,
      truncate = _ref.truncate,
      props = _objectWithoutProperties(_ref, _excluded);

  var mappedSize = (0, _react.useMemo)(function () {
    if (typeof size !== "undefined") {
      return size;
    }

    switch (Wrapper) {
      case "h1":
        return "s9";

      case "h2":
        return "s8";

      case "h3":
        return "s7";

      case "h4":
        return "s6";

      default:
        return "s4";
    }
  }, [size, Wrapper]);
  var wrapperClassName = (0, _react.useMemo)(function () {
    return [styles.wrapper, styles[color], styles[family], styles[weight], styles[Wrapper], styles[transform], styles[mappedSize], noMargin ? styles.noMargin : "", gradient ? styles.gradient : "", className].filter(Boolean).join(" ");
  }, [color, family, weight, transform, Wrapper, mappedSize, noMargin, gradient, className]);
  var content = (0, _react.useMemo)(function () {
    return typeof children === "string" && typeof truncate === "number" ? children.length > truncate ? "".concat(children.slice(0, truncate), "...") : children : children;
  }, [children, truncate]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    className: wrapperClassName
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.text
  }, content));
};

exports.Title = Title;
Title.defaultProps = {
  color: "inherit",
  transform: "uppercase",
  wrapper: "h2",
  weight: "w7",
  family: "f2",
  className: null,
  noMargin: false,
  gradient: false
};
Title.propTypes = {
  size: _propTypes.default.oneOf(["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9", "s10", "s11"]),
  weight: _propTypes.default.oneOf(["w1", "w2", "w3", "w4", "w5", "w6", "w7"]),
  family: _propTypes.default.oneOf(["f1", "f2"]),
  color: _propTypes.default.oneOf(["inherit", "black", "white", "primary"]),
  transform: _propTypes.default.oneOf(["inherit", "uppercase", "lowercase"]),
  wrapper: _propTypes.default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  truncate: _propTypes.default.number,
  noMargin: _propTypes.default.bool,
  gradient: _propTypes.default.bool
};